import { EXPERIMENTS, type ExperimentConfig } from "@/lib/experiments"

/** /ch, /ch/en, /ch/en/ → homepage; a 3rd non-empty segment means a subpage. */
function isHome(path: string): boolean {
  return path.split("/").filter(Boolean).length <= 2
}

/**
 * Best-effort: does this experiment render on `pathname`? The registry `pages`
 * field is freeform prose (`"homepage"`, `"/insurance"`, `"all CH …"`), so this
 * matches loosely and is never used to *hide* an experiment — only to surface
 * the on-page ones first.
 */
function matchesPage(exp: ExperimentConfig, pathname: string): boolean {
  return exp.pages.some((p) => {
    const tag = p.toLowerCase()
    if (tag.includes("homepage")) return isHome(pathname)
    if (tag.startsWith("/")) return pathname.includes(tag)
    if (tag.startsWith("all")) return true // site-wide (e.g. exit-intent)
    return false
  })
}

/**
 * Split the registered experiments into those likely on the current page and
 * the rest. `others` guarantees the variant switcher still lists every
 * experiment even when the freeform page match misses.
 */
export function experimentsForPage(pathname: string): {
  onPage: ExperimentConfig[]
  others: ExperimentConfig[]
} {
  const all = Object.values(EXPERIMENTS) as ExperimentConfig[]
  const onPage = all.filter((e) => matchesPage(e, pathname))
  const onSet = new Set(onPage)
  return { onPage, others: all.filter((e) => !onSet.has(e)) }
}
